import { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { listParams } from "../../services/pageOne";

const SelectAsyncGenero = (props) => {
    const [isDownload, setIsDownload] = useState(false);
    const [dataParams, setDataParams] = useState({});

    const getDefaultValue = async () => {
        if (props.id) {
            const response = await listParams(38);
            const defaultValue = response.results.filter(
                (item) => item.id === props.id
            )[0];
            props.onChange(defaultValue);
        }
    };

    async function Options(searchQuery, { page }) {
        try {
            let resp = {};
            if (isDownload) {
                resp = dataParams;
            } else {
                resp = await listParams(38);
                setDataParams(resp);
                setIsDownload(true);
            }
            return {
                options: resp.results,
                hasMore: resp.next !== null,
                additional: {
                    page: searchQuery ? 2 : page + 1,
                },
            };
        } catch (error) {}
    }
    const onChange = (option) => {
        if (typeof props.onChange === "function") {
            props.onChange(option);
        }
    };
    return (
        <>
            <AsyncPaginate
                styles={props.styles}
                key={(option) => option.id}
                value={props.value || getDefaultValue || ""}
                loadOptions={Options}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.detalle}
                onChange={onChange}
                placeholder="Seleccionar"
                additional={{
                    page: 1,
                }}
                isSearchable
                filterOption={(option, inputValue) =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                }
            />
        </>
    );
};

export default SelectAsyncGenero;
